import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const znsRoutes = ({
  ListZNS,
  ReportZNS,
  ZaloTask,
  ConnectZalo,
  DetailZNSTemplate,
}: {
  ListZNS: React.ComponentType;
  ReportZNS: React.ComponentType;
  ZaloTask: React.ComponentType;
  ConnectZalo: React.ComponentType;
  DetailZNSTemplate: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.ZALO_ZNS.LIST_ZNS.BASE} element={<ListZNS />} />
    <Route path={ROUTES.ZALO_ZNS.REPORT_ZNS.BASE} element={<ReportZNS />} />
    <Route path={ROUTES.ZALO_ZNS.ZALO_TASK_ZNS.BASE} element={<ZaloTask />} />
    <Route path={ROUTES.ZALO_ZNS.CONNECT_ZALO.BASE} element={<ConnectZalo />} />
    <Route path={ROUTES.ZALO_ZNS.LIST_ZNS.DETAIL} element={<DetailZNSTemplate />} />
  </Routes>
);
